import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '@sc/pas-common';

@Injectable()

export class DashboardService {

    constructor(private httpClient: HttpClient) {
    }

    getHasUserBackToOldPortal(): Observable<any> {
        return this.httpClient.get(`${environment.server.api.typeList}/api/Settings/oldPortal`).pipe(
            map((mapResponseWithData)));
    }

    postUserGoesBackToOldPortal(message: string) {
        return this.httpClient.post(`${environment.server.api.typeList}/api/Settings/oldPortal`, { message }).pipe(
            map(mapResponseWithData));
    }
}
